import $ from 'jquery';
import 'parsleyjs';
import { AutoScrolling } from '../../../../../../assets/js/application/auto-scrolling.js';

export async function initValidation($forms) {
    // filter shop checkout form to prevent double validation (validated via shopCheckoutValidation.js)
    $forms = $forms.not('.woocommerce-checkout');

    // require right lang based on html lang code
    let lang = 'en',
        origTitle = document.title;

    const shop = {
            global: 'input[type=hidden]',
            checkout:
                'input[name=payment_method], select[name=billing_country], select[name=shipping_country], textarea[name=order_comments], .wc_payment_methods *, input[name=terms]',
            myAccount:
                'input[name=billing_state], input[name=shipping_state], input[name=password_current], input[name=password_1], input[name=password_2]',
        },
        parsleyExcludedShop = shop.global + ',' + shop.checkout + ',' + shop.myAccount, // disable specific fields for woocommerce checkout which don't need validation to prevent errors
        parsleyOptions = {
            trigger: 'input change',
            triggerAfterFailure: 'input focusout change',
            focus: 'none', // this is done manually, as the implemented solution does not scroll nor takes offsets into account
            errorClass: 'has-error',
            successClass: 'is-valid',
            errorsWrapper: '<span class="form-errors__list"></span>',
            errorTemplate: '<span class="form-errors__list__item"></span>',
            excluded: parsleyExcludedShop,
            classHandler: ({ element }) => {
                let classHandler = element.closest('.input, .wpcf7-form-control-wrap, .floating-label');

                if (classHandler && classHandler.matches('.wpcf7-form-control-wrap')) {
                    return $(classHandler.querySelector('fieldset') || classHandler.querySelector('label'));
                }

                return $(classHandler ? classHandler : element);
            },
            errorsContainer: ({ element }) => {
                try {
                    let rootEl = element.closest('.input, .wpcf7-form-control-wrap, .floating-label'),
                        container = rootEl.querySelector('.form-errors');

                    if (!rootEl) {
                        console.warn('Root element not found for:', element);
                        return $(element);
                    }

                    if (!container) {
                        container = rootEl;

                        if (process.env.NODE_ENV !== 'production') {
                            console.group('[Template]');
                            console.warn('Error-Containers must already exist at page-loading time');
                            console.log(element);
                            console.groupEnd();
                        }
                    }

                    return $(container);
                } catch (error) {
                    console.warn('Error in errorsContainer:', error);
                    return $(element);
                }
            },
        };

    switch (document.documentElement.getAttribute('lang')) {
        case 'de':
        case 'de-AT':
        case 'de-AT-formal':
        case 'de-DE':
        case 'de-DE-formal':
            lang = 'de';
            break;
    }

    await import(/* webpackInclude: /(de|en).js$/, webpackMode: "lazy" */ 'parsleyjs/dist/i18n/' + lang + '.js'); // TODO: include more languages when required

    // add parsley only to those forms, that should be validated
    $forms.parsley(parsleyOptions);

    window.Parsley.on('form:error', (Form) => {
        // remove the loading indicator if there was an error
        Form.element.querySelectorAll('.is-loading').forEach((loader) => {
            loader.classList.remove('is-loading');
        });

        // change the document-title to reflect the error
        if (document.title.startsWith(CONFIG.i10n.document.formErrorTitle) === false) {
            document.title = CONFIG.i10n.document.formErrorTitle + document.title;
        }

        // scroll to and focus the first erroneous input
        // ensure that the label is also visible
        const autoScrolling = AutoScrolling.singleton(),
            firstInvalidField = Form.fields.find((field) => !field.isValid()),
            input = firstInvalidField.element,
            label = input.closest('.input__wrapper').querySelector('label'),
            offset = Math.max(input.offsetTop - label.offsetTop, 4); // 4 = outline-thickness

        autoScrolling.scroll(input, offset);
    })
        .on('form:success', () => {
            document.title = origTitle;
        })
        .on('field:error', (Field) => {
            Field.element.setAttribute('aria-invalid', 'true');

            // bug in parsley.js: if 2 errors are on a field at the same time, and one gets removed,
            // aria-hidden is set to true
            Field.parent.options.errorsContainer(Field).find('ul').attr('aria-hidden', 'false');
        })
        .on('field:success', ({ element }) => {
            element.setAttribute('aria-invalid', 'false');
        });

    return parsleyOptions;
}
